const getVoicemailErrorMessage = (errorMessage) => {
  switch (errorMessage) {
    case 'FileSizeLimitExceededException: The field upload exceeds its maximum permitted size of 2097152 bytes.':
      return 'Audio file is too large. The maximum audio file size is 2MB.';
    case 'upload: The uploaded file is not mono. ':
      return 'Audio file is not in the correct format. Must be: .wav, PCM Uncompressed (sometimes called u-Law), 8 or 16 Bit, 8000 HZ, Mono.';
    default:
      return 'Error. Voicemail has failed to upload.';
  }
};

export default getVoicemailErrorMessage;
